import React, {Component} from 'react';
import ExternalLanding from "../ExternalLanding";
import {externalLinks} from "../../requests/external-endpoints";

class HubSpotResourcesBuyer extends Component {
    render() {
        return <ExternalLanding url={externalLinks.resourcesBuyer} />
    }
}

export default HubSpotResourcesBuyer;
